// src/auth/tokenManager.js
// Управляет refresh-потоком и выходом из системы.

import { getRefresh, setTokens, clearTokens } from './tokenStorage';

const API_REFRESH_URL = '/api/token/refresh/';

// Глобальный "single-flight" промис, чтобы не было параллельных refresh
let refreshInFlight = null;

// Пользовательский обработчик логаута (можно переопределить из приложения)
let onLogout = () => {
  clearTokens();
  // простой редирект на страницу логина
  if (typeof window !== 'undefined') {
    window.location.href = '/sign-in';
  }
};

export function setOnLogout(fn) {
  if (typeof fn === 'function') onLogout = fn;
}

/**
 * Выполнить refresh по текущему refresh-токену.
 * Возвращает объект { access, refresh? } при успехе.
 * Бросает ошибку и запускает onLogout() при неуспехе.
 */
export async function refreshAccessToken() {
  if (refreshInFlight) {
    return refreshInFlight;
  }
  const doRefresh = async () => {
    const refresh = getRefresh();
    if (!refresh) {
      onLogout();
      throw new Error('No refresh token');
    }

    const resp = await fetch(API_REFRESH_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // SimpleJWT ожидает { refresh: "<token>" }
      body: JSON.stringify({ refresh }),
    });

    if (!resp.ok) {
      // Например, 401 с detail "Token is blacklisted" или "Token is invalid or expired"
      onLogout();
      throw new Error('Refresh failed');
    }

    const data = await resp.json();
    // SimpleJWT обычно возвращает { access: "...", refresh?: "..." }
    if (!data.access) {
      onLogout();
      throw new Error('No access in refresh response');
    }
    setTokens({ access: data.access, refresh: data.refresh });
    return data;
  };

  refreshInFlight = doRefresh()
    .catch((e) => {
      // уже обработано onLogout, просто пробросим ошибку
      throw e;
    })
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
}


